import { DataMarkerStatus } from '@weenat/client/dist/core/map'
import Icons from 'app/src/kit/Icons'
import { FC, memo } from 'react'
import { styled } from 'styled-components'

const Round = styled(Box)`
  position: absolute;

  top: -18px;
  right: -18px;

  background-color: ${(p) => p.theme.colors.grayscale.black};
  border: 1px solid ${(p) => p.theme.colors.alpha.white['10']};
  border-radius: ${(p) => p.theme.radiuses.rounded}px;

  padding: ${(p) => p.theme.spacings[300]}px;
`

export interface StatusIndicatorProps {
  /** Current status to display */
  status: DataMarkerStatus
}

const StatusIndicator: FC<StatusIndicatorProps> = ({ status }) => {
  const Icon =
    status === 'not_emitted' ? Icons.Signal : status === 'config' ? Icons.Wrench : Icons.Lock

  return (
    <Round>
      <Icon $color={'grayscale.white'} $size='md' />
    </Round>
  )
}

export default memo(StatusIndicator)
